import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
// import {
//   MsalService
// } from '@azure/msal-angular';
import { Subject } from 'rxjs';
import { HeaderService } from '../../../features/services/header.service';
import { CompanyService } from '../../../features/services/company.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { UnsavedTrackingService } from '../../../services/unsaved-changes.service';

@Component({
  selector: 'app-voucher-header',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxSpinnerModule, DialogModule],
  templateUrl: './voucher-header.component.html',
  styleUrl: './voucher-header.component.css'
})
export class VoucherHeaderComponent implements OnInit, OnDestroy {
  showLoginButton = false;
  showCompanyHeader = false;
  isSidebarOpen = false;
  loginDisplay = false;
  isIframe = false;
  companyName: string | null = null;
  roleCode = '';
  menuList: any[] = [];
  isLoggedIn = false;
  currentUrl: string = '';
  showHeader = true;
  showLogoutConfirm = false;

  private destroy$ = new Subject<void>();
  sessionTimeout: any;

  constructor(
    private router: Router,
    private headerService: HeaderService,
    // private msalService: MsalService,
    private companyService: CompanyService,
    private ngx: NgxSpinnerService,
    private unsavedService: UnsavedTrackingService
  ) {
    this.router.events.subscribe(event => {
      this.checkLogin();
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        this.currentUrl = url;

        // ALWAYS close sidebar on navigation
        this.isSidebarOpen = false;

        if (url.includes('/login') || url.includes('/verify-otp')) {
          this.showHeader = false;
        }
        else {
          this.showHeader = true;
        }

        if (url === '/' || url === '') {
          this.showLoginButton = true;
          this.showCompanyHeader = false;
        } else if (url === '/home' || url.includes('/account-settings') || url === '/user-profile' || url === '/voucher-setup' || url.includes('/voucher-list')
          || url === '/redemption-report' || url.includes('/business-review') || url === '/business-search'
        ) {
          this.showLoginButton = false;
          this.showCompanyHeader = true;
        } if (url === '/faq' || url === '/contact-us') {
          this.showLoginButton = !this.isLoggedIn;
          this.showCompanyHeader = this.isLoggedIn;
        } else {
          this.showLoginButton = false;
          this.showCompanyHeader = false;
        }
      }
    });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  ngOnInit(): void {
    this.roleCode = sessionStorage.getItem('roleCode')?.toString() || '';
    this.headerService.companyName$.subscribe(name => {
      this.isLoggedIn = true;
      this.showHeader = true;
      this.companyName = name;
      this.roleCode = sessionStorage.getItem('roleCode')?.toString() || '';
      this.getMenuList(this.roleCode);
    });
    this.checkLogin();
  }

  checkLogin() {
    const companyId = sessionStorage.getItem('companyId');

    this.isLoggedIn =
      companyId !== null &&
      companyId !== '' &&
      companyId !== 'null' &&
      companyId !== 'undefined';
  }

  goHomeFromLogo(): void {
    if (this.isLoggedIn) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/'])
    }
  }

  // SSO Login/Logout
  ssoLogin() {
    // this.msalService.loginRedirect({
    //   scopes: ['api://6f8a5994-72ce-44a7-8377-3d85e9942e18/access_as_user']
    // });
  }

  ssoLogout() {
    sessionStorage.clear();
    localStorage.clear();
    // this.msalService.instance.clearCache();
    // this.msalService.logoutRedirect({
    //   postLogoutRedirectUri: 'https://immunize.wagsoutreach.com'
    // });
  }

  // Custom Login/Logout
  login() {
    if (this.isUserLoggedIn()) {
      this.callSecureApi();
    }
    else {
      this.router.navigate(['/login']);
    }
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['']);
  }

  isUserLoggedIn(): boolean {
    return !!localStorage.getItem(
      'token'
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  openLogoutConfirm(): void {
    this.closeSidebar();
    this.showLogoutConfirm = true;
  }

  confirmLogout(): void {
  this.showLogoutConfirm = false;

  this.unsavedService.bypassCheck();

  sessionStorage.clear();
  localStorage.clear();
  this.router.navigate(['']);
}

  cancelLogout(): void {
    this.showLogoutConfirm = false;
  }

  callSecureApi(): void {
    this.companyService.secure().subscribe({
      next: res => {
        sessionStorage.setItem('companyId', res.companyId);
        this.sessionTimeout.start();
        sessionStorage.setItem('email', res.userEmail);
        sessionStorage.setItem('roleCode', res.roleCode);
        sessionStorage.setItem('companyName', res.companyName);
        this.headerService.setCompanyName(res.companyName);
        this.ngx.hide();
        this.router.navigate(['/home']);
      },
      error: err => {
        this.ngx.hide();
        this.router.navigate(['/login']);
        console.error('API error', err);
      }
    });
  }

  getMenuList(roleCode: string) {
    if (roleCode === '1') {
      this.menuList = [
        {
          name: 'Home',
          route: '/home'
        },
        {
          name: 'Account Settings',
          route: '/account-settings'
        },
        {
          name: 'Setup a New Voucher',
          route: '/voucher-setup'
        },
        {
          name: 'Vouchers & Agreements',
          route: '/voucher-list'
        },
        // {
        //   name: 'Redemption Report',
        //   route: '/redemption-report'
        // },
        {
          name: 'Business Review',
          route: '/business-review'
        },
        {
          name: 'Business Search',
          route: '/business-search'
        },
        // {
        //   name: 'Business Verification',
        //   route: '/w9-business-verification'
        // },
        // {
        //   name: 'Redemption Upload',
        //   route: '/redemption-upload'
        // },
        {
          name: 'Logout',
          route: '/logout'
        },
      ];
    }
    else {
      this.menuList = [
        {
          name: 'Home',
          route: '/home'
        },
        {
          name: 'Account Settings',
          route: '/account-settings'
        },
        {
          name: 'Setup a New Voucher',
          route: '/voucher-setup'
        },
        {
          name: 'Vouchers & Agreements',
          route: '/voucher-list'
        },
        // {
        //   name: 'Business Verification',
        //   route: '/w9-business-verification'
        // },
        // {
        //   name: 'Redemption Report',
        //   route: '/redemption-report'
        // },
        {
          name: 'Logout',
          route: '/logout'
        },
      ];
    }
  }
}
